module.exports = __webpack_public_path__ + "assets/img/iOS_Dark.94184abe.svg";